exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form #news_video_asset[data-v-369fa462] {\n  width: 13em;\n}\n.button.is-primary[data-v-369fa462] {\n  background-color: #72BECC;\n  border-color: transparent;\n  color: white;\n}\n.select[data-v-369fa462]:not(.is-multiple):not(.is-loading)::after {\n  border-color: #72BECC;\n  right: 1.125em;\n  z-index: 4;\n}", ""]);

// exports
